import { render, staticRenderFns } from "./BagShopIcon.vue?vue&type=template&id=9597f1ba&scoped=true&"
import script from "./BagShopIcon.vue?vue&type=script&lang=js&"
export * from "./BagShopIcon.vue?vue&type=script&lang=js&"
import style0 from "./BagShopIcon.vue?vue&type=style&index=0&id=9597f1ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9597f1ba",
  null
  
)

export default component.exports